<template>
  <div id="margin-setting-summary-pivot">
    <CostSummaryPivot  v-if="partCost && costItemRecords && currency"
                       :currency="currency"
                      :data="costItemRecords"
                      :partCost="partCost"
                      :loading="loading"></CostSummaryPivot>
  </div>
</template>

<script>
import CostSummaryPivot from '@/view/cost/components/reports/cost-summary-pivot'
import { mapActions } from 'vuex'
export default {
  name: "margin-setting-summary-pivot",
  components: {
    CostSummaryPivot
  },
  props: {
    costEstimatorId: {
      type: Number,
      require: true
    }
  },
  mounted () {
    this.loadCostEstimatorInfo(this.costEstimatorId)
  },
  data () {
    return {
      loading: false,
      scope: '',
      marginSetting: {},
      currencyConversionRate: 1.0,
      localCurrency: 'CNY',
      aggregations: [],
      partCost: null,
      curency: ''
    }
  },
  watch: {
    partCost: {
      handler (newVal) {
        if (newVal) {
          this.init()
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'getCostedBomSummary',
      'getCostEstimatorInfo'
    ]),
    async init() {
      if (this.partCost) {
        this.currency = this.partCost.currency
        this.currencyConversionRate = this.partCost.exchange_rate
        this.localCurrency = 'CNY'
      }
      this.loadSummary()
    },
    loadCostEstimatorInfo(id) {
      this.getCostEstimatorInfo(id).then(res => {
        if (res.status === 200) {
          this.partCost = res.data.root_assembly_part_cost
        }
      })
    },
    loadSummary() {
      this.loading = true
      this.getCostedBomSummary(this.costEstimatorId).then((res) => {
        this.aggregations = res.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  computed: {
    costItemRecords: function () {
      let data = _.clone(this.aggregations)
      return _.map(data, (item) => {
        item.cost_quantity = this.partCost.quantity
        if (item.currency !== this.currency) {
          if (item.currency === this.localCurrency) {
            item.price_amount = item.price_amount / this.currencyConversionRate
            item.price_amount_taxed = item.price_amount_taxed / this.currencyConversionRate
            item.price = item.price / this.currencyConversionRate
            item.price_taxed = item.price_taxed / this.currencyConversionRate
            item.cost = item.cost / this.currencyConversionRate
            item.margin = item.margin / this.currencyConversionRate
            item.vat_amount = item.vat_amount / this.currencyConversionRate
            item.currency = this.currency
          } else {
            item.price_amount = item.price_amount * this.currencyConversionRate
            item.price_amount_taxed = item.price_amount_taxed * this.currencyConversionRate
            item.price = item.price * this.currencyConversionRate
            item.price_taxed = item.price_taxed * this.currencyConversionRate
            item.cost = item.cost * this.currencyConversionRate
            item.margin = item.margin * this.currencyConversionRate
            item.vat_amount = item.vat_amount * this.currencyConversionRate
            item.currency = this.currency
          }
        }
        return item
      })
    }
  }
}
</script>

<style lang="less">
  #cost-summary-pivot-table .pivot-table {
    padding: 5px 0;
    div.mb-3 button.btn.btn-outline-primary { display: none; }
    .text-right { text-align: right; }
  }
</style>
